<template>
  <div class="och-pay">
    <p class="call">Please call <a href="tel:+18554384936">1-855-438-4936</a> if you have any questions</p>
    <form class="form" @submit.prevent="makePayment">
      <h3>Payment Form</h3>
      <div class="info">
        <input type="text"
          placeholder="Email"
          class="info-email-inp"
          v-model="email"
          :disabled="loading"
        />
        <div class="info-amount">
          <p>$</p>
          <input type="text"
            @input="checkMaxAmount"
            placeholder="Enter payment amount"
            class="info-amount-inp"
            v-model="amount"
            v-mask="'####'"
            :disabled="loading"
          />
        </div>
      </div>
      <p v-if="exceeded">Max limit for one payment is 1500. Please split up any payments larger than 1500.</p>
      <div class="card">
        <div class="card-header">
          <h3>Pay With Card</h3>
          <h3>Total: ${{Number(amount)}}</h3>
        </div>
        <div class="card-form">
          <div class="card-cc">
            <input type="text"
              placeholder="Card Number"
              v-model="cc"
              v-mask="'#### #### #### ####'"
              :disabled="loading"
            />
            <input type="text"
              placeholder="MM/YY"
              maxlength="5"
              v-model="exp"
              v-mask="'##/##'"
              :disabled="loading"
            />
            <input type="text"
              placeholder="CVV"
              v-mask="'####'"
              maxlength="4"
              v-model="cvv"
              :disabled="loading"
            />
          </div>
          <div class="card-billing">
            <input type="text"
              placeholder="Name on card"
              style="grid-area: a"
              v-model="name"
              :disabled="loading"
            />
            <div class="card-billing-sel" style="grid-area: b">
              <select :disabled="loading" v-model="country">
                <option value="" disabled>Select country</option>
                <option value="US">United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="AF">Afghanistan</option>
                <option value="AX">Åland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option valut="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BH">Bahrain</option>
                <option value="BS">Bahamas</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia, Plurinational State of</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, the Democratic Republic of the</option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Côte d'Ivoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curaçao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and McDonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">Korea, Democratic People's Republic of</option>
                <option value="KR">Korea, Republic of</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK">Macedonia, the Former Yugoslav Republic of</option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option valuev="OM">Oman</option>
                <option valuev="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestine, State of</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PT">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Réunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthélemy</option>
                <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin (French part)</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten (Dutch part)</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS">South Georgia and the South Sandwich Islands</option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan, Province of China</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela, Bolivarian Republic of</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.S.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </select>
            </div>
            <input type="text"
              v-if="country === 'US'"
              placeholder="Zipcode"
              style="grid-area: c"
              class="card-billing-zip-inp"
              v-model="zipcode"
              v-mask="'#####'"
              :disabled="loading"
            />
          </div>
          <div class="card-form-button">
            <!-- <p>Customer satisfaction is backed by a 30-day money back guarantee. If you are not satisfied with your tutor please contact support@och.com to inquire about a refund.</p> -->
            <button :disabled="!isFormValid() || loading">
              <span v-if="loading">
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#fff">
                  <g fill="none" fill-rule="evenodd">
                    <g transform="translate(1 1)" stroke-width="2">
                      <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                        <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(238.858 18 18)">
                          <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/>
                        </path>
                    </g>
                  </g>
                </svg>
              </span>
              <span v-if="!loading">Pay ${{Number(amount)}}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
    <div class="secure">
      <img src="@/assets/images/secure-logos.png">
      <p>Protecting your personal information is extremely important to you. Academic All Stars certifies that it is safe and secure for you to provide your personal information.</p>
    </div>
  </div>
</template>
<script>
import EventBus from '@/utils/event-bus'
export default {
  data: function () {
    return {
      email: '',
      amount: '',
      country: '',
      cc: '',
      exp: '',
      cvv: '',
      name: '',
      zipcode: '',
      loading: false,
      exceeded: false
    }
  },
  methods: {
    checkMaxAmount () {
      this.exceeded = this.amount > 1500
    },
    onResetForm () {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    isFormValid () {
      return (
        this.cc &&
        this.exp &&
        this.cvv &&
        this.email &&
        this.name &&
        // this.zipcode &&
        this.country
      ).length > 0 &&
      this.amount > 0 &&
      !this.exceeded
    },
    async makePayment () {
      this.loading = true

      const {
        email,
        amount,
        cc,
        exp,
        cvv,
        name,
        zipcode,
        country
      } = this

      if (this.isFormValid()) {
        const res = await fetch('/.netlify/functions/ochPay', {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email,
            amount,
            cc: cc.replace(/[^0-9.]+/g, ''),
            exp: exp.replace(/[^0-9.]+/g, ''),
            cvv,
            name,
            country,
            zipcode
          })
        })

        this.processResult(await res.json())
      }
    },
    sendMail (data) {
      fetch('/.netlify/functions/ochMailGun', {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
    },
    processResult (res) {
      if (res.result === 1) {
        EventBus.$emit('PAYMENT_POPUP_OPEN')
        this.sendMail(res)
        this.onResetForm()
        this.loading = false
      } else {
        EventBus.$emit('PAYMENT_ERROR_POPUP_OPEN', res)
        this.onResetForm()
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
  $desktop: "(min-width: 600px)";
  $xs: "(max-width: 350px)";

  .och-pay {
    padding: 60px 16px;
    max-width: 620px;
    margin: 0 auto;

    * {
      box-sizing: border-box;
    }

    h3 {
      font-weight: 900;
      color: #FC5E3F;
      font-size: 26px;
      margin: 0 0 5px;

      @media #{$desktop} {
        font-size: 35px;
      }
    }

    .call {
      font-size: 14px;

      a {
        color: #FC5E3F;
        text-decoration: none;
      }
    }

    .info {
      display: grid;
      grid-template-rows: 1fr 1fr;
      grid-gap: 10px;
      margin-bottom: 20px;

      @media #{$desktop} {
        grid-template-rows: none;
        grid-template-columns: 1fr 1fr;
      }

      input {
        display: block;
        outline: none;
        font-size: 15px;
        padding: 10px;
        width: 100%;
        margin: 0;
        height: 40px;
      }

      &-email-inp {
        border: 1px solid #B0B0B0;
        border-radius: 4px;
      }

      &-amount-inp {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top: 1px solid #B0B0B0;
        border-right: 1px solid #B0B0B0;
        border-bottom: 1px solid #B0B0B0;
        border-left: none;
      }

      &-amount {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;

        p {
          color: white;
          padding: 10px;
          background-color: #FC5E3F;
          margin: 0;
          text-align: center;
          height: 40px;
          width: 40px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
      }
    }

    .card {
      // margin-bottom: 20px;

      &-header {
        display: grid;
        grid-template-columns: 1fr auto;

        @media #{$xs} {
          h3 {
            font-size: 20px;
          }
        }
      }

      &-form {
        border-radius: 4px;
        padding: 16px;
        background-color: #F4F9FA;
        border: 1px solid #C8E1EA
      }

      &-cc {
        border: 1px solid #C8E1EA;
        border-radius: 4px;
        background-color: white;
        padding: 10px;
        display: grid;
        grid-template-columns: 1fr 60px 40px;
        margin-bottom: 10px;

        input {
          margin: 0;
          font-size: 15px;
          outline: none;
          border: none;
        }
      }

      &-billing {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 10px;
        grid-template-areas: 'a a a'
                             'b b c';

        @media #{$desktop} {
          grid-template-columns: 1fr 1fr 1fr 120px;
          grid-template-areas: 'a a b c'
        }

        input {
          border: 1px solid #C8E1EA;
          border-radius: 4px;
          background-color: white;
          padding: 10px;
          margin: 0;
          font-size: 15px;
          outline: none;
        }

        &-sel {
          border: 1px solid #C8E1EA;
          border-radius: 4px;
          background-color: white;
          padding: 8px 5px;

          select {
            font-size: 15px;
            width: 100%;
            background-color: white;
            outline: none;
            border: none;
          }
        }

        &-zip-inp {
          width: 100%;
        }
      }

      .card-form-button {
        // @media #{$desktop} {
        //   font-size: 35px;
        //   display: grid;
        //   grid-template-columns: 1fr 200px;
        //   grid-column-gap: 20px;
        // }

        // p {
        //   line-height: 1.6;
        //   font-size: 10px;
        //   margin-bottom: 0;
        // }

        button {
          background-color: #FC5E3F;
          color: white;
          border: none;
          border-radius: 4px;
          width: 100%;
          height: 40px;
          font-size: 15px;
          outline: none;
          cursor: pointer;
          margin-top: 10px;
          padding: 0;

          &:disabled {
            background-color: grey;
          }

          span {
            display: block;
          }

          svg {
            line-height: 0;
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .secure {
      font-size: 12px;
      font-weight: bold;
      line-height: 1.6;
      padding: 20px 0;
      grid-template-rows: 1fr 1fr;

      @media #{$desktop} {
        display: grid;
        grid-template-rows: none;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 20px;
      }

      p {
        margin: 0;
      }

      img {
        width: 100%;
      }
    }
  }
</style>
